import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const TreeWrapper = styled.div`
	height: 400px;
	.rst__moveHandle,
	.rst__rowContents {
		box-shadow: none;
		border: none;
	}

	.rst__rowContents {
		padding-left: 0;
		min-width: 150px;
		background-color: transparent;
	}

	.rst__moveHandle {
		background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwIDlINFYxMUgyMFY5Wk00IDE1SDIwVjEzSDRWMTVaIiBmaWxsPSIjOTk5OTk5Ii8+Cjwvc3ZnPgo=)
			no-repeat center;
		width: 36px;
		min-width: 36px;
	}

	.rst__row {
		box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
		border-radius: 2px;
	}

	.rst__row:hover {
		box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.3);
	}

	.rst__rowTitle,
	.rst__rowLabel {
		width: 100%;
		display: block;
		padding: 0;
		cursor: context-menu;
	}

	.rst__rowContentsDragDisabled {
		padding-left: 12px;
	}

	.rst__rowWrapper {
		padding: 3px 10px 3px 0;
	}

	.rst__collapseButton,
	.rst__expandButton {
		width: 12px;
		height: 12px;
		box-shadow: 0 0 0 2px ${colors.grey6};
	}

	.rst__expandButton {
		background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+CiAgPGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz4KICA8ZyBzdHJva2U9IiM0RDRENEQiIHN0cm9rZS13aWR0aD0iMS45IiA+CiAgICA8cGF0aCBkPSJNNC41IDloOSIvPjxwYXRoIGQ9Ik05IDQuNXY5Ii8+CiAgPC9nPgo8L3N2Zz4=)
			no-repeat center;
	}

	.rst__collapseButton {
		background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+Cgk8Y2lyY2xlIGN4PSI5IiBjeT0iOSIgcj0iOCIgZmlsbD0iI0ZGRiIgLz4KCTxnIHN0cm9rZT0iIzRENEQ0RCIgc3Ryb2tlLXdpZHRoPSIxLjkiPgoJCTxwYXRoIGQ9Ik00LjUgOWg5IiAvPgoJPC9nPgo8L3N2Zz4=)
			no-repeat center;
	}

	.rst__lineChildren::after {
		height: 3px;
		background: ${colors.grey4};
	}

	.rst__lineHalfHorizontalRight::before,
	.rst__lineFullVertical::after,
	.rst__lineHalfVerticalTop::after,
	.rst__lineHalfVerticalBottom::after {
		background: ${colors.grey4};
	}

	.rst__placeholder {
		min-height: 500px;
	}

	.rst__rowSearchMatch {
		outline: none;
		opacity: 1 !important;
	}

	.rst__node:first-child .rst__lineBlock,
	.rst__node:first-child .rst__collapseButton {
		display: none;
	}

	.rst__node:first-child .rst__nodeContent {
		left: 16px !important;
	}
`;

export const ToggleWrapper = styled.div`
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	letter-spacing: 0.3px;
	margin-left: auto;
	justify-content: flex-end;
	display: flex;
	line-height: 40px;
`;
export const Title = styled.div`
	color: ${colors.grey5};
	min-width: 100px;
`;

export const ChartCard = styled.div`
	box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
	&:nth-child(3n) {
		grid-column: 1 / span 2;
	}
`;
